import React, { Component } from 'react';
import Card from '../../Components/Card/bigCard';
import { Link } from 'react-router-dom';
import ErrorIcon from "../../Components/Icons/dist/ErrorIcon";
import '../../Components/Icons/css/animations.css';
import {connect} from 'react-redux';
import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const getState = (state) =>{
    return {
        url : state.url
    }
}

const Dispatch = (dispatch) =>{
    return {
        loadCurrentEvent : (event) =>{
            let action = {
                type:'loadCurrentEvent',
                event:event
            }
            dispatch(action)
        }
    }
}

class Declined extends Component {

    componentWillMount = () =>{
        let url = this.props.url
        let funcion = this.props.loadCurrentEvent
        axios.get(url+'/api/v1/events/byuser/?user='+cookies.get('key'))
        .then(response =>{
            console.log(response.data)
            let data = JSON.stringify(response.data[0])
            funcion(data)
        })
        .catch(err => {
            console.log(err)
        })
    }
    
    render() {
        return (
            <div className="container pt-6">
                <Card>
                    <div className="d-inline back">
                        <Link to='/' className="back-btn"><i className="fa fa-caret-left"></i> Atrás</Link>
                    </div>
                    <div className="offset-sm-1 col-sm-10 text-center">
                        <ErrorIcon />
                    <h5 className=" strong p-4">Lo sentimos, la transacción fué rechazada.</h5>
                    
                    <div className="map-container pt-6">
                        <div className="row">
                            <div className="col-8 offset-2">
                                   
                            </div>
                        </div>
                    </div>
                        <div className="pt-6">
                            <div className="text-center pt-8 pb-6">
                                <Link to='/checkout' style={{color:'#fff'}} className="btn btn-lg btn-warning">VOLVER</Link>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

    export default connect(getState, Dispatch)(Declined);



// WEBPACK FOOTER //
// ./src/Pages/Declined/index.js